// Derive the RDrive SPA base URL from the API URL the host handed us, mirroring
// the server's rule (strip a leading "api-" from the host). Every link the
// backend generates (rdrive_deep_link / rdrive_finder_url / export downloads
// resolved absolute) is built against this origin, so it's the reference for
// "does this link belong to the host SPA". Returns null when the config isn't
// usable so callers can fall back (plain text, external-tab navigation).
export function deriveSpaBase(apiUrl) {
  if (!apiUrl) return null
  try {
    const u = new URL(apiUrl.startsWith('http') ? apiUrl : `https://${apiUrl}`)
    const host = u.host.replace(/^api-/, '')
    return `${u.protocol}//${host}`
  } catch {
    return null
  }
}
